export default __webpack_public_path__ + "static/media/clarinet_three.fb50bd7e.mp3";